module.exports = __webpack_public_path__ + "static/media/rejectCallIcon.3dc57447.svg";